<template>
  <div>
    <div class="d-flex align-center flex-wrap" style="gap: 16px">
      <template v-if="activeTab === ShowPlansType.ALL_PLANS">
        <div v-for="item in show" :key="item.id" class="parent-box">
          <div
            :class="{
              'gradient-card':
                item.value === FiltersType.VIP && item.value !== activeShow
            }"
            @click="setShow(item.value)"
          >
            <div class="box" :class="{ active: item.value === activeShow }">
              {{ item.label }}
            </div>
          </div>
        </div>
        <v-divider vertical class="custom-divider"></v-divider>
        <!--        compare asset-->
        <div
          v-if="activeTab === ShowPlansType.ALL_PLANS"
          class="box"
          @click="setCompareAsset"
          :class="{ active: compareAsset }"
        >
          {{ $t("staking.stakingPlans.filters.COMPARE_ASSET") }}
        </div>

        <!--    search-->
        <div
          v-if="activeTab === ShowPlansType.ALL_PLANS"
          class="gray--text d-flex align-center border rounded-lg ps-2 search-container"
        >
          <img src="../../../../assets/image/staking/search.svg" alt="search" />
          <input
            class="ms-5 gray1--text"
            @input="$emit('searchHandler', $event)"
            :placeholder="$t('staking.stakingPlans.filters.searchPlaceHolder')"
          />
        </div>
      </template>
    </div>
    <div class="d-flex align-center flex-wrap mt-6" style="gap: 16px">
      <div
        v-for="item in filters[activeTab]"
        :key="`${activeTab}-${item.id}`"
        class="parent-box"
      >
        <div
          class="box"
          :class="{ active: item.value === activeFilter }"
          @click="setFilter(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FiltersType, ShowPlansType } from "@/store/types";

export default {
  computed: {
    FiltersType() {
      return FiltersType;
    },
    ShowPlansType() {
      return ShowPlansType;
    }
  },
  props: ["activeTab", "activeFilter", "activeShow", "compareAsset"],
  data() {
    return {
      show: [
        {
          id: 0,
          label: this.$t("staking.stakingPlans.filters.ALL"),
          value: FiltersType.ALL
        },
        {
          id: 1,
          label: this.$t("staking.stakingPlans.filters.VIP"),
          value: FiltersType.VIP
        }
      ],
      filters: {
        ALL_PLANS: [
          {
            id: 0,
            label: this.$t("staking.stakingPlans.filters.MAX_PROFIT"),
            value: FiltersType.MAX_PROFIT
          },
          {
            id: 1,
            label: this.$t("staking.stakingPlans.filters.MIN_PROFIT"),
            value: FiltersType.MIN_PROFIT
          },
          {
            id: 2,
            label: this.$t("staking.stakingPlans.filters.MAX_TIME"),
            value: FiltersType.MAX_TIME
          },
          {
            id: 3,
            label: this.$t("staking.stakingPlans.filters.MIN_TIME"),
            value: FiltersType.MIN_TIME
          },
          {
            id: 4,
            label: this.$t("staking.stakingPlans.filters.FIXED"),
            value: FiltersType.FIX
          },
          {
            id: 5,
            label: this.$t("staking.stakingPlans.filters.FLEXIBLE"),
            value: FiltersType.FLEXIBLE
          }
        ],
        MY_PLANS: [
          {
            id: 0,
            label: this.$t("staking.stakingPlans.filters.ACTIVE"),
            value: FiltersType.ACTIVE
          },
          {
            id: 1,
            label: this.$t("staking.stakingPlans.filters.TERMINATED"),
            value: FiltersType.TERMINATED
          },
          {
            id: 2,
            label: this.$t("staking.stakingPlans.filters.CANCELED"),
            value: FiltersType.CANCELED
          }
        ]
      }
    };
  },
  methods: {
    setShow(value) {
      this.$emit("setActiveShow", value);
    },
    setFilter(value) {
      this.$emit("setActiveFilter", value === this.activeFilter ? "" : value);
    },
    setCompareAsset() {
      this.$emit("setCompareAsset");
    }
  }
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 400px) {
  .search-container {
    max-width: 100% !important;
  }
  .box,
  .parent-box {
    width: 100% !important;
  }
}
.search-container {
  max-width: 260px;
  width: 100%;

  height: 40px;
  background-color: var(--v-gray10-base) !important;

  input {
    outline: none;
  }

  img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}

.gradient-card {
  padding: 1px;
  border-radius: 8px;
  background: linear-gradient(#f1ac1c, #2354e7);
  & > div {
    border-radius: 7px;
  }
}

.box {
  height: 42px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 120px;
  border-radius: 7px;
  background-color: var(--v-gray10-base);
  border: 1px solid var(--v-gray-base);
}

.active {
  background-color: var(--v-primary-base) !important;
  color: white;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
}
</style>
